// Project
import createApplyCommonRequestOptions from "./createApplyCommonRequestOptions";

/**
 * Create an API POST function (url, body -> Promise<Response>).
 *
 * @param {Function} postFn - Function to perform POST request.
 * Expected to match the Fetch API (Request -> Promise<Response>).
 * @param {Object} clientParameters - Object containing API client parameters.
 * @param {String} clientParameters.rootUrl - Root URL for API.
 * @param {String} clientParameters.token - Bearer token for API authentication.
 * @return {Function} Function which accepts a URI and returns a request promise.
 */
function createPost(postFn, clientParameters) {
  const optionApplicator = createApplyCommonRequestOptions(clientParameters);

  return (url, body) => {
    const postRequest = optionApplicator(
      new Request(
        `${clientParameters.rootUrl}${url}`,
        {
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json; charset=utf-8"
          },
          method: "POST"
        }
      )
    );

    return postFn(postRequest);
  };
}

export default createPost;
